import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Tabs, Tab, Button } from "@mui/material";
import "./mywallet.css";

import MyWalletSpot from "./MyWalletSpot";
import MyWalletFuture from "./MyWalletFuture";
import MyWalletOption from "./MyWalletOption";
import {
  getDashBoardInfo,
  getExchangeFeaturesCurrency,
} from "../../CoreDataService";
import InfoIcon from "@mui/icons-material/Info";

const MyWalletDashboard = () => {
  const theme = localStorage.getItem("theme");
  const { brokerMarkets } = useSelector((state) => state);
  const [value, setValue] = useState(
    localStorage.getItem("walletActiveTab") || "spot"
  );

  const labels = ["SPOT"];
  const values = ["spot"];
  if (brokerMarkets?.isFutures === 1) {
    labels.push("FUTURES");
    values.push("future");
  }
  if (brokerMarkets?.isOptions === 1) {
    labels.push("OPTIONS");
    values.push("options");
  }

  useEffect(() => {
    getDashBoardInfo();
    getExchangeFeaturesCurrency();
  }, []);

  useEffect(() => {
    const activeTab = localStorage.getItem("walletActiveTab") || "spot";
    if (activeTab === "future" && brokerMarkets?.isFutures === 0) {
      setValue("spot");
      localStorage.setItem("walletActiveTab", "spot");
    } else if (activeTab === "options" && brokerMarkets?.isOptions === 0) {
      setValue("spot");
      localStorage.setItem("walletActiveTab", "spot");
    }
  }, [brokerMarkets]);

  const handleTabChange = (index) => {
    setValue(values[index]);
    localStorage.setItem("walletActiveTab", values[index]);
  };

  return (
    <div style={{ padding: "20px", borderRadius: "10px", marginTop: "10px" }}>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {labels.map((label, index) => (
            <Button
              key={label}
              onClick={() => handleTabChange(index)}
              sx={{
                flex: 1,
                mx: 1,
                color:
                  value === values[index]
                    ? "var(--btn-color)"
                    : "var(--text-color)",
                fontSize: "20px",
                fontWeight: "bold",
                textTransform: "none",
                borderRadius: "4px",
              }}
            >
              {label}
            </Button>
          ))}
        </Box>
      </Box>

      {value === "spot" && <MyWalletSpot />}
      {value === "future" && <MyWalletFuture />}
      {value === "options" && <MyWalletOption />}
    </div>
  );
};

export default MyWalletDashboard;
